import React from 'react';
import ButtonText from "./Typography/ButtonText";
import { PUBLIC_TAB_TO_CONTENT_GAP_CLASS } from "../../sections/Public/shared/publicLayoutSpec";

/**
 * Tabs component
 * @param {string[]} tabs - Array of tab labels
 * @param {number} activeTab - Index of the active tab
 * @param {function} onTabChange - Callback when tab is changed
 * @param {React.ReactNode[]} children - Tab panels
 */
const Tabs = ({ tabs, activeTab, onTabChange, children }) => {
  return (
    <div className="w-full">
      <div className="border-b border-mediumgray">
        <div className="flex flex-wrap gap-x-6 gap-y-1 -mb-px">
          {tabs.map((tab, idx) => {
            const isActive = idx === activeTab;
            return (
              <button
                key={tab}
                type="button"
                onClick={() => onTabChange(idx)}
                className={`pb-3 px-1 bg-transparent transition-colors ${
                  isActive
                    ? "text-primaryblue"
                    : "text-offblack hover:text-primaryblue"
                }`}
              >
                <ButtonText
                  variant="SecondaryText"
                  className={isActive ? "text-primaryblue" : ""}
                >
                  {tab}
                </ButtonText>
              </button>
            );
          })}
        </div>
      </div>
      <div className={PUBLIC_TAB_TO_CONTENT_GAP_CLASS}>{children[activeTab]}</div>
    </div>
  );
};

export default Tabs;
